import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const KotakCheckout = ({ response }) => {
    const location = useLocation()
    const responseData = location.state?.responseData

    useEffect(() => {
        document.CReqForm.submit()
    })
    return <div dangerouslySetInnerHTML={{ __html: responseData }}></div>
}

export default KotakCheckout
